@if (!loading) {
    <section>
        <div class="container margin-bottom-20 word-wrap">
            <h2 class="heading-2" [translate]="title"></h2>
            <p [translate]="body"></p>
            <button class="button button-primary button-large pull-right" (click)="close()" [translate]="'cart.confirm.ok'"></button>
        </div>
    </section>
}
